jQuery(document).ready(function($){
	//Options - media uploader
	let settingsDiv = 'coplayer-options';
	let mediaUploader;
	let el;
	$('#' + settingsDiv + ' .upload_image .upload_button').click(function(e) {
		el = $(this);
		e.preventDefault();
		if(mediaUploader) {
			mediaUploader.open();
			return;
		}

		mediaUploader = wp.media.frames.file_frame = wp.media({
			title: 'Choose Image',
			library: {
				type: 'image'
			},
			button: {
				text: 'Choose Image'
			}, 
			multiple: false
		});

		mediaUploader.on('select', function() {
			let attachment = mediaUploader.state().get('selection').first().toJSON();
			updateLogoField(el, attachment);
		});
		mediaUploader.open();
	});

	$('#' + settingsDiv + ' .upload_image').each(function(){
		updatePlayerLogo($(this));
	});

	$('#' + settingsDiv + ' .clear_upload').click(function(e){
		e.preventDefault();
		updateLogoField($(this), false);
	});

	function updateLogoField(el, attachment) {
		let parent = el.closest('.upload_image');
		if(attachment) {
			parent.find('.image_id').val(attachment.id);
			parent.find('.image_preview').attr('src', attachment.url).css('display', 'block');
			parent.find('.clear_upload').show();
		} else {
			parent.find('.image_id').val('');
			parent.find('.image_preview').attr('src', '').hide();
			parent.find('.clear_upload').hide();
		}
		updatePlayerLogo(parent);
	}

	function updatePlayerLogo(el) {
		let color = el.attr('color');
		let url = el.find('.image_preview').attr('src') ? el.find('.image_preview').attr('src') : el.attr('default_logo');
		el.find('.coplayer img.' + color).attr('src', url);
		el.find('.coplayer').show();
	}
});